<template>
  <div id="container">
    <!-------------- 合同总览 -------------->
    <contract-overview ref="contractOverviewRefs"></contract-overview>
    <div class="product-status">
      <div class="bold"></div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="item.title"
          :name="item.name"
          class="tab-text"
          v-for="item in contractDetailsTabs"
          :key="item.name"
        ></el-tab-pane>
      </el-tabs>
      <!-------------- 财务信息 -------------->
      <financial-information
        ref="financialInformationRefs"
        :queryParams="financialInformationParams"
        v-show="activeName === '账务信息'"
      ></financial-information>
      <!-------------- 产品清单 -------------->
      <product-list ref="productListRefs" v-show="activeName === '产品清单'"></product-list>
      <!-------------- 退货产品 -------------->
      <returned-products ref="returnedProductsRefs" v-show="activeName === '退货产品'"></returned-products>
      <!-------------- 发货管理 -------------->
      <delivery-management ref="deliveryManagementRefs" v-show="activeName === '发货管理'"></delivery-management>
      <!-------------- 票据管理 -------------->
      <bill-manage ref="billManageRefs" v-show="activeName === '票据管理'"></bill-manage>
      <!-------------- 任务列表 -------------->
      <task-list ref="taskListRefs" v-show="activeName === '任务列表'"></task-list>
      <!-------------- 售后管理 -------------->
      <after-sales-manage ref="afterSalesManageRefs" v-show="activeName === '售后管理'"></after-sales-manage>
      <!-------------- 相关附件 -------------->
      <related-accessory ref="relatedAccessoryRefs" v-show="activeName === '相关附件'"></related-accessory>
    </div>
  </div>
</template>
<script>
// 初始化页面接口queryPurchaseFinance
import { queryPurchaseFinance } from '@/api/purchase/purchasePlanList'
import contractOverview from './contractOverview' // 合同总览
import productList from './productList' // 产品清单
import financialInformation from './financialInformation' // 财务信息
import returnedProducts from '../returnsManage/returnedProducts' // 退货产品
import deliveryManagement from '../deliveryManage/deliveryManagement' // 发货管理
import billManage from '../billManage/billManage' // 票据管理
import taskList from './taskList' // 任务列表
import afterSalesManage from '../afterSalesManage/afterSalesManage' // 售后管理
import relatedAccessory from './relatedAccessory' // 相关附件
import { contractDetailsTabs } from '../../util/data'
export default {
  components: {
    'contract-overview': contractOverview,
    'financial-information': financialInformation,
    'product-list': productList,
    'delivery-management': deliveryManagement,
    'bill-manage': billManage,
    'task-list': taskList,
    'returned-products': returnedProducts,
    'after-sales-manage': afterSalesManage,
    'related-accessory': relatedAccessory
  },

  data () {
    return {
      productList: [], // 产品清单
      contractOverview: {}, // 合同总览
      params: {},
      financialInformationParams: {},
      activeName: '账务信息',
      contractDetailsTabs: contractDetailsTabs,
      sendType: ''
    }
  },
  mounted () {
    this.getList()
    if (this.$route.query.activeName === undefined) {
      this.activeName = '账务信息'
    } else {
      this.activeName = this.$route.query.activeName
    }
    if (this.activeName === '发货管理') {
      this.$refs.deliveryManagementRefs.getIsHaveRemind()
    } else if (this.activeName === '产品清单') {
      this.$refs.productListRefs.onInitial()
    } else if (this.activeName === '合同总览') {
      this.getList()
    } else if (this.activeName === '票据管理') {
      this.$refs.billManageRefs.onInitial()
    } else if (this.activeName === '相关附件') {
      this.$refs.relatedAccessoryRefs.getList()
    } else if (this.activeName === '退货产品') {
      this.$refs.returnedProductsRefs.getList()
    } else if (this.activeName === '售后管理') {
      this.$refs.afterSalesManageRefs.getList()
    } else if (this.activeName === '任务列表') {
      this.$refs.taskListRefs.getList()
    }
  },
  methods: {
    // 初始化请求数据
    getList () {
      queryPurchaseFinance(this.$route.query.pcbId)
        .then(res => {
          if (res.data.code === 200) {
            this.params = res.data.obj
            this.financialInformationParams = res.data.obj.purchaseFinancesVo
            this.contractOverview = {
              // 合同预览
              pcbNumber: res.data.obj.purchaseContractBasesVo.pcbNumber, // 合同编码
              suName: res.data.obj.purchaseContractBasesVo.suName, // 供应商
              supplierContractNumber:
                res.data.obj.purchaseContractBasesVo.supplierContractNumber, // 供应商合同编号
              purchaseTotal: res.data.obj.purchaseContractBasesVo.purchaseTotal, // 合同金额
              actualTotal: res.data.obj.purchaseContractBasesVo.actualTotal, // 已收账款
              accountsPayable:
                res.data.obj.purchaseContractBasesVo.accountsPayable, // 应收账款
              accountsDue: res.data.obj.purchaseContractBasesVo.accountsDue, // 已到期应收账款
              accountsOutstanding:
                res.data.obj.purchaseContractBasesVo.accountsOutstanding, // 未到期应收账款
              signState: res.data.obj.purchaseContractBasesVo.signState, // 合同状态
              signTime: res.data.obj.purchaseContractBasesVo.signTime, // 签订时间
              sendType: res.data.obj.purchaseContractBasesVo.sendType, // 发货方式
              staffUsename: res.data.obj.purchaseContractBasesVo.staffUsename, // 当前负责人
              updateDate: res.data.obj.purchaseContractBasesVo.updateDate, // 更新时间
              spId: res.data.obj.purchaseContractBasesVo.spId, // 供应商Id
              contractState: res.data.obj.purchaseContractBasesVo.contractState,
              ocbMark: res.data.obj.purchaseContractBasesVo.ocbMark, // 备注
              stockupType: res.data.obj.purchaseContractBasesVo.stockupType // 备货方式
            }
            this.sendType = res.data.obj.purchaseContractBasesVo.sendType
            this.$refs.deliveryManagementRefs.onInitial(this.sendType)

            this.$refs.contractOverviewRefs.onInitial(this.contractOverview)
            this.$refs.financialInformationRefs.onInitial(
              this.params.purchaseContractFinancesVoList,
              this.params.purchaseFinancesVo
            )
          }
        })
        .catch(err => {
          console.log(err)
        })
    },

    // 品牌,系列,产品tabs
    handleClick (tab) {
      this.activeName = tab.name
      if (this.activeName === '发货管理') {
        this.$refs.deliveryManagementRefs.getIsHaveRemind()
      } else if (this.activeName === '产品清单') {
        this.$refs.productListRefs.onInitial()
      } else if (this.activeName === '合同总览') {
        this.getList()
      } else if (this.activeName === '票据管理') {
        this.$refs.billManageRefs.onInitial()
      } else if (this.activeName === '相关附件') {
        this.$refs.relatedAccessoryRefs.getList()
      } else if (this.activeName === '退货产品') {
        this.$refs.returnedProductsRefs.getList()
      } else if (this.activeName === '售后管理') {
        this.$refs.afterSalesManageRefs.getList()
      } else if (this.activeName === '任务列表') {
        this.$refs.taskListRefs.getList()
      }
    }
  }
}
</script>
<style lang="scss" scoped></style>
